module.exports = __webpack_public_path__ + "img/logo-open-banking.c89bdcf2.png";